angular.module('jv.CandAdd', [
    'jv',
    'jv.Common.Directives.jvSelect2ModalDropdown',
    'JV.Core.Directives',
    'ngSanitize',
    'ngStorage',
    'App.ajax.service',
    'jv.Common.Modal',
    'jv.Common.Directives.Formtemplate',
    'jv.Common.Filters',
    'jv.Common.Directives.Datepicker',
    'jv.common.numberFormatter.directive',
    'jv.common.currency.directive',
    'jv.candidate.appSource.controller',
    'jv.addCandidate.controller'
])
.value('modalTemplateUrl', '../../htm/common/modal.html')
.factory('newCandidateFormTypeFactory', function($routeParams) {
    return function() {
        var props = {};
        if($routeParams && $routeParams.formType === 'refer') {
            props.url = '/jhire/action/application/refer';
            props.name = 'refer';
            props.source = false;
            props.notify = true;
            props.addRequisition = true;
            props.parseResumeURL = '/jhire/action/resource/parseResume';
            props.resume = {
                url: '/jhire/action/resource/resume?extractInfo=true&getDownloadToken=true',
                multipleUpload: false,
                allowedFileTypes: ['pdf','doc','docx','txt','rtf'],
                removeFileTypeText: true,
                uploadButtonText: 'UPLOAD_RESUME'
            };
            props.cv = {
                url: '/jhire/action/resource/coverLetter?',
                multipleUpload: false,
                allowedFileTypes: ['pdf','doc','docx','txt','rtf'],
                removeFileTypeText: true,
                uploadButtonText: 'UPLOAD_COVER_LETTER'
            };
            props.attachment = {
                url:'/jhire/action/resource/attachment?',
                multipleUpload: true,
                disAllowedFileTypes:['zip','dmg','exe'],
                removeFileTypeText: true
            };
        }else if($routeParams.formType === 'agency'){
            if($routeParams.clientId) {
                props.url = '/jhire/action/agency/{0}/addCandidate/{1}?clientId={2}'.format($routeParams.companyId, $routeParams.jobId, $routeParams.clientId);
            } else{
                props.url = '/jhire/action/agency/{0}/addCandidate/{1}'.format($routeParams.companyId, $routeParams.jobId);
            }
            props.name = 'agency';
            props.source = false;
            props.notify = false;
            props.addRequisition = false;
            props.parseResumeURL = '/jhire/action/agency/resource/parseResume?companyId={0}'.format($routeParams.companyId);
            props.resume = {
                url: '/jhire/action/agency/resource/attachment?kind=Resume&companyId={0}&jobId={1}'.format($routeParams.companyId, $routeParams.jobId),
                multipleUpload: false,
                removeFileTypeText: true,
                uploadButtonText: 'UPLOAD_RESUME',
                downloadURL: '/jhire/action/agency/resource/download?fId={0}&fileDownloadToken={1}&' + ('&companyId={0}&jobId={1}'.format($routeParams.companyId, $routeParams.jobId))
            };
            props.cv = {
                url: '/jhire/action/agency/resource/attachment?kind=CoverLetter&companyId={0}&jobId={1}'.format($routeParams.companyId,$routeParams.jobId),
                multipleUpload: false,
                removeFileTypeText: true,
                uploadButtonText: 'UPLOAD_COVER_LETTER'
            };
            props.attachment = {
                url:'/jhire/action/agency/resource/attachment?kind=Portfolio&companyId={0}&jobId={1}'.format($routeParams.companyId, $routeParams.jobId),
                multipleUpload: true,
                disAllowedFileTypes:['zip','dmg','exe'],
                removeFileTypeText: true
            };
        }else{
            props.url = '/jhire/action/application/addCandidate';
            props.name = 'candidate';
            props.source = true;
            props.notify = true;
            props.addRequisition = true;
            props.parseResumeURL = '/jhire/action/resource/parseResume';
            props.resume = {
                url: '/jhire/action/resource/resume?extractInfo=true&getDownloadToken=true',
                multipleUpload: false,
                allowedFileTypes: ['pdf','doc','docx','txt','rtf'],
                removeFileTypeText: true,
                uploadButtonText: 'UPLOAD_RESUME'
            };
            props.cv = {
                url: '/jhire/action/resource/coverLetter?',
                multipleUpload: false,
                allowedFileTypes: ['pdf','doc','docx','txt','rtf'],
                removeFileTypeText: true,
                uploadButtonText: 'UPLOAD_COVER_LETTER'
            };
            props.attachment = {
                url:'/jhire/action/resource/attachment?',
                multipleUpload: true,
                disAllowedFileTypes:['zip','dmg','exe'],
                removeFileTypeText: true
            };
        }
        return props;
    };
});
